/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationDetailsForOci extends models.LocationDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LocationDetailsForOci");
    }

    getFixupPrototypeFunction() { return LocationDetailsForOci.fixupPrototype; }

    static newInstance(model: Partial<LocationDetailsForOci>): LocationDetailsForOci {
        let obj = Object.assign(new LocationDetailsForOci(), model);
        LocationDetailsForOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationDetailsForOci>): LocationDetailsForOci {
        if (!model) return null;
        return LocationDetailsForOci.newInstance(<LocationDetailsForOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationDetailsForOci) {
        if (!obj) return;

        models.LocationDetailsForOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationDetailsForOci): boolean {
        if (models.LocationDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LocationDetailsForOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
